<template>
    <button role="button"
        class="default-btn outlined position-relative transition border-0 fw-medium text-white p-10 rounded-4 bg-success d-inline-block text-decoration-none"
        v-on:click="recoveryPassword()">
        <span class="spinner-border spinner-border-sm me-8" role="status" aria-hidden="true" v-if="loading"></span>
        {{ $t('cta.recovery_password') }}</button>
    <AlertModal id="recovery_modal" :title="$t('feature.auth.$recovery_user_password.title')"
        :message="modal_message" />
</template>

<script lang="ts">
import AlertModal from '@/components/Widgets/AlertModal.vue';
import API from '@/services/api/api.service';
import { Modal } from 'bootstrap';
import { defineComponent } from 'vue';


export default defineComponent({
    name: "RecoveryPasswordButton",
    props: {
        user_id: {
            type: String,
            required: true,
        }
    },
    components: {
        AlertModal
    },
    data() {
        return {
            loading: false as boolean,
            modal: null as Modal | null,
            modal_message: '' as string,
        }
    },
    mounted() {
        this.modal = new Modal('#recovery_modal', {});
    },
    methods: {
        recoveryPassword() {
            this.loading = true;
            API.recoveryUserPassword(this.user_id).then((response) => {
                if (response.data.success === true) {
                    this.modal_message = this.$t('feature.auth.$recovery_user_password.success_message');
                    console.debug('recovery_password', this.user_id);
                } else {
                    this.modal_message = this.$t('feature.auth.$recovery_user_password.error_message');
                }
            }).catch((error) => {
                this.modal_message = this.$t('feature.auth.$recovery_user_password.error_message');
            }).finally(() => {
                this.loading = false;
                this.modal?.show();
            });
        },
    }
})
</script>